/// JTF3-added-AB-22-05-12

'use strict'

jQuery(document).ready(function($) {

	if (localStorage.getItem('cookies') == 'true') {
		$('.cookies__container').remove();
	} else {
		$('.cookies__container').show();
	}

	/**
	 * If the cookie policy has been dismissed, set a local storage item so the
	 * next time someone views the page (without clearing cache) they won't be
	 * shown the policy again.
	 */
	$('.cookies__accept--button__dismiss').click(function() {
		localStorage.setItem('cookies', true);
		$('.cookies__container').remove();
	});
});

